import { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import { useRouter } from "next/router";

import { apiGetPlatformOptions } from "../../../lib/api/platform";
import { engageState } from "../../../atoms/platform";

import Agenda from "../../../components/Engage/AgendaV2";
import Loading from "../../../components/Shared/Loading";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}

export default function AgendaDetails() {
  const isMounted = useMounted();
  const router = useRouter();
  const { client } = router.query;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [clientState, setClientState] = useRecoilState(engageState);

  useEffect(() => {
    async function fetchClient() {
      const results = await apiGetPlatformOptions(client);
      if (results) {
        setClientState(results);
      }
    }
    if (client) {
      if (!clientState) {
        fetchClient();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  return (
    <div className="h-screen flex overflow-hidden bg-white default-scrollbar">
      {isMounted ? (
        <>
          <main className="flex-1 relative overflow-y-auto focus:outline-none">
            <Agenda />
          </main>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}
